import styled from "@emotion/styled";
import {
  fontWeight,
  fontSize,
  breakpointValues,
  colorPrimitives,
} from "@atlas-int/tokens";
export const PageSection = styled.div`
  margin: 5vh 0 5vh;
  display: flex;
  min-width: 250px;
  grid-column: 2;
`;

/**
 * Testimonial quote text on the landing page. Rendered as a <blockquote>
 * (the correct element for a quotation) rather than a heading. The explicit
 * `margin: 0.83em 0` reproduces the vertical spacing the old <h2> received
 * from the browser default — and cancels the 40px side indent a <blockquote>
 * would otherwise get — so the tag change doesn't shift the layout.
 */
export const Quote = styled.blockquote`
  font-weight: ${fontWeight.light};
  font-size: ${fontSize["2xl"]};
  color: ${colorPrimitives.landingMuted};
  margin: 0.83em 0;
`;

export const breakpointSmall = breakpointValues.xs;

export const ArrowIcon = () => {
  return (
    <svg viewBox="0 0 16 16">
      <polygon points="7.2,0 7.2,2.5 11.7,2.5 0,14.2 1.8,16 13.5,4.3 13.5,8.8 16,8.8 16,2.5 16,1.8 16,0 "></polygon>
    </svg>
  );
};
